import { notifyError } from "@/modules/error/errorReporting.ts";

export function unhandledNestedError(error: unknown, message = "Unhandled error while already handling an error") {
    console.error(message, error);
    notifyError(error, { tags: ["unhandledNestedError"] });
}
